
import { computed, defineComponent } from 'vue'
import TableSimple from '@/components/elements/TableSimple.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import HospitalTag from '@/components/elements/HospitalTag.vue'
import HospitalContactBtn from '@/components/block/HospitalContactBtn.vue'
import HospitalDetailGraph from '@/components/block/HospitalDetailGraph.vue'
import { numberFormatAddComma } from '@/utils/commonMethods'
import { GMAP_EMBED_API_KEY } from '@/utils/commonDataset'

export default defineComponent({
  components: {
    TableSimple,
    HeadingLv2,
    HeadingLv3,
    HospitalTag,
    HospitalDetailGraph,
    HospitalContactBtn
  },

  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    state: {
      type: Object,
      default: () => ({})
    },
    features: {
      type: Array,
      default: () => []
    }
  },

  setup(props) {
    const aboutData = computed(() => {
      return [
        {
          th: '病院名',
          td: props.detail.hospital_name,
          kana: props.detail.hospital_name_kana
            ? `(${props.detail.hospital_name_kana})`
            : ''
        },
        {
          th: '所在地',
          td: props.detail.prefectures + props.detail.hospital_address
        },
        { th: '病院種別', td: props.detail.hospital_class },
        {
          th: '募集定員',
          td: props.detail.positions_num
            ? numberFormatAddComma(props.detail.positions_num) + '名'
            : ''
        },
        {
          th: '診療科目',
          td: props.detail.departments
            ? props.detail.departments.join('、')
            : ''
        }
      ]
    })
    const graphData = computed(() => {
      return [
        {
          label: '症例数',
          rate: props.detail.cases_num
        },
        {
          label: '給与',
          rate: props.detail.hospital_salary
        },
        {
          label: '指導医数',
          rate: props.detail.instructors_num
        },
        {
          label: '倍率',
          rate: props.detail.magnification
        }
      ]
    })
    const basicData = computed(() => {
      return [
        {
          th: '救急指定',
          td: props.detail.designated_hospital
            ? props.detail.designated_hospital.join('、')
            : ''
        },
        {
          th: '病床数',
          td: props.detail.bed_num ? props.detail.bed_num + '床' : ''
        },
        { th: '病床数内訳', td: props.detail.bed_detail || '' },
        { th: '病院URL', td: props.detail.hospital_url || '', link: true },
        {
          th: '診療科目',
          td: props.detail.departments
            ? props.detail.departments.join('、')
            : ''
        }
      ]
    })
    const directorData = computed(() => {
      return [
        { th: '院長名', td: props.detail.director_name },
        { th: '出身大学', td: props.detail.director_graduating_school || '' },
        {
          th: '専門科目',
          td: props.detail.director_specialty
            ? props.detail.director_specialty.join('、')
            : ''
        }
      ]
    })
    const doctorData = computed(() => {
      return [
        {
          th: '医師数',
          td: props.detail.doctor_num
            ? numberFormatAddComma(props.detail.doctor_num) + '名'
            : ''
        }
      ]
    })
    const patientData = computed(() => {
      return [
        {
          th: '外来患者数（1日平均）',
          td: props.detail.outpatient_num_avg
            ? numberFormatAddComma(props.detail.outpatient_num_avg) + '名'
            : ''
        },
        {
          th: '入院患者数（1日平均）',
          td: props.detail.inpatient_num_avg
            ? numberFormatAddComma(props.detail.inpatient_num_avg) + '名'
            : ''
        },
        {
          th: '救急外来患者 年間件数',
          td: props.detail.emergency_num_avg
            ? numberFormatAddComma(props.detail.emergency_num_avg) + '件'
            : '',
          thChild: 'うち時間外件数',
          tdChild: props.detail.out_of_hours
            ? numberFormatAddComma(props.detail.out_of_hours) + '件'
            : '',
          smRowLayout: true
        },
        {
          th: '救急車搬送 年間件数',
          td: props.detail.ambulance_num
            ? numberFormatAddComma(props.detail.ambulance_num) + '件'
            : '',
          thChild: 'うち時間外件数',
          tdChild: props.detail.ambulance_out_of_hours
            ? numberFormatAddComma(props.detail.ambulance_out_of_hours) + '件'
            : '',
          smRowLayout: true
        }
      ]
    })
    const accessData = computed(() => {
      return [
        {
          th: '所在地',
          td: `〒${props.detail.post_code}<br>${props.detail.prefectures}${props.detail.hospital_address}`
        }
      ]
    })
    const mapQuery = computed(() => {
      return props.detail.latitude && props.detail.longitude
        ? `${props.detail.latitude},${props.detail.longitude}`
        : `${props.detail.prefectures}${props.detail.hospital_address}`
    })
    const isNotEmptyData = (data: any) => {
      let res = false
      data.forEach((el: any) => {
        if (el.td) res = true
      })
      return res
    }

    return {
      aboutData,
      graphData,
      basicData,
      directorData,
      doctorData,
      patientData,
      accessData,
      mapQuery,
      isNotEmptyData,
      numberFormatAddComma,
      GMAP_EMBED_API_KEY
    }
  }
})
